export default {
    mapper: {
        relations: 'Abstract Class',
    },
};
